export namespace FileUploadActions {
  const prefix = '[File Upload]';

  export class AddFile {
    static readonly type = `${ prefix } Add file`;

    constructor(public file: File) {

    }
  }

  export class StartUploading {
    static readonly type = `${ prefix } Start uploading`;

    constructor() {

    }
  }

  export class UploadingError {
    static readonly type = `${ prefix } Uploading error`;

    constructor() {

    }
  }

  export class UploadingSuccess {
    static readonly type = `${ prefix } Uploading success`;

    constructor() {

    }
  }

  export class SetInitialPreviewUrl {
    static readonly type = `${ prefix } Set initial preview url`;

    constructor(public previewUrl: any, public uploadedFileId: number) {

    }
  }

  export class ResetState {
    static readonly type = `${ prefix } Reset state`;

    constructor() {

    }
  }

  export class ResetPreview {
    static readonly type = `${ prefix } Reset preview`;

    constructor() {

    }
  }
}